<template>
    <li class="list-group-item subscription-entry mb-4">
        <div class="header pb-3" @click="toggleCard" >
            <subscription-entry-header
                :toggled="toggle"
                :hasMultipleEntries="hasMultipleEntries"
                :header-data="entryData"
                :subscription-data="entryData"
            ></subscription-entry-header>
        </div>
        <div class="body" v-if="toggle && historyLoaded">
            <b-tabs content-class="mt-3">
                <b-tab active :title="$t('cdb.subscriptions.tab_subscriptions')">
                    <section id="subscription-tab">
                        <cdb-tab-subscription
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-subscription>
                    </section>
                </b-tab>
                <b-tab v-if="!this.subsidiaryHasOwnPayment" :title="$t('cdb.subscriptions.tab_payments')">
                    <section id="payments-tab">
                        <cdb-tab-payment
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-payment>
                    </section>
                </b-tab>
                <b-tab :title="$t('cdb.subscriptions.tab_documents')">
                    <section id="documents-tab">
                        <cdb-tab-documents
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-documents>
                    </section>
                </b-tab>

                <b-tab :title="$t('cdb.subscriptions.tab_personal_data')">
                    <section id="personal-data-tab">
                        <cdb-tab-personal-data
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-personal-data>
                    </section>
                </b-tab>

                <b-tab v-if="entryData.extension_request.feature_active && entryData.fixed_duration == 1" :title="$t('cdb.subscriptions.tab_subscription_extension')">
                    <section id="subscription-extension-tab">
                        <cdb-tab-subscription-extension
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-subscription-extension>
                    </section>
                </b-tab>

                <b-tab v-if="entryData.reco_engine" :title="$t('cdb.subscriptions.tab_retention')">
                    <section id="retention-tab">
                        <cdb-tab-retention
                            class="pt-3"
                            :subscription-data="entryData"
                        ></cdb-tab-retention>
                    </section>
                </b-tab>
            </b-tabs>
        </div>
        <div class="footer text-center px-5" @click="toggleCard" v-if="hasMultipleEntries">
            <font-awesome-icon icon="fa-chevron-down" v-if="!toggle"/>
            <font-awesome-icon icon="fa-chevron-up" v-if="toggle"/>
        </div>
    </li>
</template>

<script>
import { BTab, BTabs } from 'bootstrap-vue'
import SubscriptionEntryHeader from "../molecules/SubscriptionEntryHeader.vue";
import CdbTabSubscription from "./CdbTabSubscription.vue";
import CdbTabPayment from "./CdbTabPayment.vue";
import CdbTabDocuments from "./CdbTabDocuments.vue";
import CdbTabPersonalData from "./CdbTabPersonalData.vue";
import CdbTabSubscriptionExtension from './CdbTabSubscriptionExtension.vue';
import CdbTabRetention from './CdbTabRetention.vue';


export default {
    name: 'SubscriptionEntry',
    components: {
        CdbTabDocuments,
        CdbTabPayment,
        CdbTabSubscription,
        CdbTabPersonalData,
        CdbTabSubscriptionExtension,
        CdbTabRetention,
        SubscriptionEntryHeader,
        BTab, BTabs,
    },
    props: {
        hasMultipleEntries: {
            type: Boolean,
            required: true
        },
        entryData: {
            type: Object,
            required: false
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            toggle: this.buildToggle(),
            historyLoaded: this.getHistory()
        }
    },
    methods: {
        toggleCard(){
            if(this.hasMultipleEntries){
                this.toggle = !this.toggle
                this.getHistory()
            }
        },
        buildToggle() {
            return !this.hasMultipleEntries
        },
        getHistory() {
            if (!this.entryData.history) {
                this.$axios.post(`/api/v1/dashboard/subscription_history`, {
                    subscription_uuid: this.entryData.uuid
                })
                .then(response => {
                    this.entryData.history = response.data
                    this.historyLoaded = true
                })
                .catch(error => {
                    console.error(error)
                })
            } else {
                this.historyLoaded = true
            }
        }
    },
    computed: {
        subsidiaryHasOwnPayment() {
            return this.entryData.subsidiary_has_own_payment_handling === 1 ?? false
        }
    },
}
</script>
<style lang="scss">
.subscription-entry {
    -webkit-transition: all 2s ease-in-out;
    -moz-transition: all 2s ease-in-out;
    -ms-transition: all 2s ease-in-out;
    -o-transition: all 2s ease-in-out;
    transition: all 2s ease-in-out;
}
</style>
